import LoadingSpinner from "./LoadingSpinner";

export default function LoadingSpinnerWrapper() {
  return (
    <div className="flex items-center justify-center w-full h-full md:min-h-0 min-h-[400px]">
      <LoadingSpinner />
    </div>
  );
}
